import { FC, useMemo } from 'react';
import { Tabs } from 'antd';
import { ActionEntityType } from '@pmp/api';
import { useTranslation } from 'react-i18next';
import { CrudMode } from '@ohpen/enso-ui';

import { FormSchemaProps } from '../interfaces';
import { ExclusivesTab, NotesTab, ProcurationFeesTab, FirmDetailsTab } from '.';

export const FirmsFormSchema: FC<FormSchemaProps> = ({ form, mode, selectsOptions, defaultComplianceStatus, entityId }) => {
  const { t } = useTranslation();
  const entityType = ActionEntityType.LENDER_FIRMS;

  const items = useMemo(
    () => [
      {
        key: 'registration',
        label: t('lender.firms.labels.firmsDetails'),
        children: <FirmDetailsTab form={form} mode={mode} selectsOptions={selectsOptions} defaultComplianceStatus={defaultComplianceStatus} />,
      },
      {
        key: 'procuration-fees',
        label: t('lender.firms.labels.procurationFees'),
        children: <ProcurationFeesTab form={form} mode={mode} selectsOptions={selectsOptions} />,
      },
      {
        key: 'exclusives',
        label: t('lender.firms.labels.exclusives'),
        children: <ExclusivesTab form={form} mode={mode} selectsOptions={selectsOptions} />,
      },
      ...(CrudMode.CREATE === mode
        ? []
        : [{
          key: 'notes',
          label: t('lender.firms.labels.notes'),
          children: <NotesTab form={form} mode={mode} selectsOptions={selectsOptions} entityType={entityType} entityId={entityId} />,
        }]),

    ],
    [form, mode, selectsOptions, defaultComplianceStatus, t, entityType, entityId],
  );

  return (
    <div className="enso-ui-tabs-wrapper">
      <Tabs items={items} />
    </div>
  );
};
